import { render } from "./WaitView.vue?vue&type=template&id=d67f202a"
import script from "./WaitView.vue?vue&type=script&lang=js"
export * from "./WaitView.vue?vue&type=script&lang=js"

import "./WaitView.vue?vue&type=style&index=0&id=d67f202a&lang=css"
import "./WaitView.vue?vue&type=style&index=1&id=d67f202a&lang=css"

import exportComponent from "/Users/romuloreis/Documents/CakeCherries/mural-viewer-2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__